// extracted by mini-css-extract-plugin
export default {"Admin":"styles_Admin__zI--U","content":"styles_content__H3Jqv"};